import { AssetAttribute } from "../../api";

export function assetAttributeNameSelector(asset: AssetAttribute): string {
    return asset.title;
}
